import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//js文件
import VueI18n from 'vue-i18n';
import { initI18n } from "@/utils/i18n";
import routesI18n from "@/router/i18n";
import basucSettingsMessages from '../i18n-basucSettings';
// 注册i18n实例并引入语言文件，文件格式等下解析
// const i18n = new VueI18n({
//   locale: 'zh',
//   messages: {
//     'zh': require('../i18n-basucSettings'),
//   }
// })

var i18n = initI18n();
var messages = basucSettingsMessages.messages;
Object.keys(messages).forEach(function (lang) {
  i18n.mergeLocaleMessage(lang, messages[lang]);
});
console.log('i18n', i18n);
/**
 * 添加用户字段列表
 * @type {[{prop: string, name: VueI18n.TranslateResult, disabled: boolean, type: string},{prop: string, name: VueI18n.TranslateResult, disabled: boolean, type: string},{prop: string, name: VueI18n.TranslateResult, disabled: boolean, type: string},{prop: string, name: VueI18n.TranslateResult, disabled: boolean, type: string},{radioGrop: [{title: VueI18n.TranslateResult, value: number},{title: VueI18n.TranslateResult, value: number}], prop: string, name: VueI18n.TranslateResult, disabled: boolean, type: string}]}
 */
export var addList = [{
  type: 'input',
  name: i18n.t('account.emailAccount'),
  prop: 'account',
  disabled: false,
  length: 60
}, {
  type: 'input',
  name: i18n.t('account.name'),
  prop: 'name',
  disabled: false,
  length: 18
}, {
  type: 'inputPwd',
  name: i18n.t('account.pwd'),
  disabled: false,
  prop: 'pwd',
  length: 20
}, {
  type: 'inputPwd',
  name: i18n.t('account.confirmPwd'),
  disabled: false,
  prop: 'confirmPwd',
  length: 20
}, {
  type: 'radio',
  name: i18n.t('account.setAdmin'),
  prop: 'isAdmin',
  radioGrop: [{
    value: 0,
    title: i18n.t('account.no')
  }, {
    value: 1,
    title: i18n.t('account.yes')
  }],
  disabled: false
}];

/**
 * 编辑用户字段列表
 * @type {[{prop: string, name: VueI18n.TranslateResult, disabled: boolean, type: string},{prop: string, name: VueI18n.TranslateResult, disabled: boolean, type: string},{radioGrop: [{title: VueI18n.TranslateResult, value: number},{title: VueI18n.TranslateResult, value: number}], prop: string, name: VueI18n.TranslateResult, disabled: boolean, type: string}]}
 */
export var editList = [{
  type: 'input',
  name: i18n.t('account.emailAccount'),
  prop: 'account',
  disabled: true
}, {
  type: 'input',
  name: i18n.t('account.name'),
  prop: 'name',
  disabled: false,
  length: 18
}, {
  type: 'radio',
  name: i18n.t('account.setAdmin'),
  prop: 'isAdmin',
  radioGrop: [{
    value: 0,
    title: i18n.t('account.no')
  }, {
    value: 1,
    title: i18n.t('account.yes')
  }],
  disabled: false
}];

/**
 * 修改密码字段列表
 * @type {[{prop: string, name: VueI18n.TranslateResult, disabled: boolean, type: string},{prop: string, name: VueI18n.TranslateResult, disabled: boolean, type: string}]}
 */
export var pwdList = [{
  type: 'inputPwd',
  name: i18n.t('account.newPwd'),
  disabled: false,
  prop: 'newPwd',
  length: 20
}, {
  type: 'inputPwd',
  name: i18n.t('account.confirmPwd'),
  disabled: false,
  prop: 'confirmNewPwd',
  length: 20
}];